module.exports = __webpack_public_path__ + "static/media/suite.4eb18583.svg";